import {
  getCountryListFetch,
  getmediaSourceFetch,
  getSummaryListFetch,
  getPredictDataFetch,
} from "../../api/api";
// import Axios from "axios"
const state = {
  mediaList: [],
  countryList: [],
  summaryList: [],
  totalEstimateTimes: 0,
  totalRoi: 0,
  popuRoi: 0,
  increRoi: 0,
  country: null,
  PredictDataList: [],
  PredictDimension: 1,
  totalIncomeDiffer: 0,
  totalPopuDiffer: 0,
  totalArpuDiffer: 0,
};

const actions = {
  async getCountryListAndMedia ({ commit }, { afid, cb }) {
    try {
      const data1 = await getCountryListFetch({ afid });
      const data2 = await getmediaSourceFetch();
      Promise.all([data1, data2]).then((result) => {
        commit("setcountryAndMedia", result);
        cb(result[0]);
      });
    } catch (e) {
      throw new Error(e);
    }
  },
  async getSummaryList ({ commit }, { param, cb }) {
    try {
      const data = await getSummaryListFetch({ data: JSON.stringify(param) });
      cb(data);
      data.collecs.map((v) => {
        v.estimateTimes = Number(v.estimateTimes);
        v.estimateValue = Number(v.estimateValue);
        v.increRoi = v.increRoi ? Number(v.increRoi.toFixed(2)) : 0;
        v.popuRoi = v.popuRoi ? Number(v.popuRoi.toFixed(2)) : 0;
      });
      commit("setSummaryList", data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async getPredictData ({ commit }, { param, cb }) {
    try {
      const data = await getPredictDataFetch({ data: JSON.stringify(param) });
      // Axios.get("/api/getpredictData", {
      //   params: param
      // }).then((data) => {
      //   console.log(data);
      //   cb(data)
      //   commit('setPredictDimension', param.dimension)
      //   commit('setPredictDataList', data.data)
      // });
      cb(data);
      commit("setPredictDimension", param.dimension);
      commit("setPredictDataList", data);
      // data.collecs.map(v => {
      //   v.estimateTimes = Number(v.estimateTimes);
      //   v.estimateValue = Number(v.estimateValue);
      //   v.increRoi = v.increRoi ? Number(v.increRoi.toFixed(2)) : 0;
      //   v.popuRoi = v.popuRoi ? Number(v.popuRoi.toFixed(2)) : 0
      // })
    } catch (e) {
      throw new Error(e);
    }
  },
};

const mutations = {
  setcountryAndMedia (state, data) {
    state.countryList = data[0].countryList;
    state.mediaList = data[1].mediaList;
  },
  setSummaryList (state, data) {
    state.summaryList = data.collecs.map((itemA, index) => {
      return { ...state.summaryList[index], ...itemA, };
    });
    state.totalEstimateTimes = data.totalEstimateTimes;
    state.totalRoi = data.totalRoi;
    state.increRoi = data.increRoi;
    state.popuRoi = data.popuRoi;
    state.totalIncomeDiffer = data.totalIncomeDiffer;
    state.totalPopuDiffer = data.totalPopuDiffer;
    state.totalArpuDiffer = data.totalArpuDiffer;
  },
  setLtvSummary (state, data) {
    state.ltv180 = data.ltv180;
    switch (data.dimension) {
      case '1':
        state.summaryList = state.summaryList.map((item) => {
          const findObj = data.collecs.find((itemA) => itemA.date === item.date);
          item.ltv180 = findObj?.ltv180 || 0;
          item.roi180 = item.cresCost && findObj?.ltv180
            ? ((findObj.ltv180 / item.cresCost) * 100).toFixed(2) + "%"
            : "-";
          return item
        });
        break;
      case '2':
        state.summaryList = state.summaryList.map((item) => {
          const findObj = data.collecs.find((itemA) => itemA.geo === item.geo);
          item.ltv180 = findObj?.ltv180 || 0;
          item.roi180 = item.cresCost && findObj?.ltv180
            ? ((findObj.ltv180 / item.cresCost) * 100).toFixed(2) + "%"
            : "-";
          return item
        });
        break;
      case '3':
        state.summaryList.map((item) => {
          const findObj = data.collecs.find((itemA) => itemA.mediaSource === item.mediaSource);
          item.ltv180 = findObj?.ltv180 || 0;
          item.roi180 = item.cresCost && findObj?.ltv180
            ? ((findObj.ltv180 / item.cresCost) * 100).toFixed(2) + "%"
            : "-";
          return item
        });
        break;
      case '4':
        state.summaryList.map((item) => {
          const findObj = data.collecs.find((itemA) => itemA.mediaSource === item.mediaSource && itemA.campaign === item.campaign);
          item.ltv180 = findObj?.ltv180 || 0;
          item.roi180 = item.cresCost && findObj?.ltv180
            ? ((findObj.ltv180 / item.cresCost) * 100).toFixed(2) + "%"
            : "-";
          return item
        });
        break;
    }
  },
  setCountry (state, data) {
    state.country = data.country;
  },
  setPredictDataList (state, data) {
    state.PredictDataList = data.predictionDatas;
  },
  setPredictDimension (state, data) {
    state.PredictDimension = data;
  },
};

export default {
  state,
  actions,
  mutations,
};
